import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { getWindowObject } from '../../../utils/window';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { Curtain } from '../../curtain/Curtain';

import { BlockingModalContent } from './BlockingModalContent';

interface GenericErrorConnectedProps {
  inCurtain?: boolean;
}

export const GenericErrorConnected: FunctionComponent<GenericErrorConnectedProps> = ({ inCurtain }): ReactElement => {
  const windowObject = getWindowObject();

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        windowObject.location.reload();
      }}
    />,
  ];

  useEffect(() => {
    if (inCurtain) return;
    // Error may occur on initial loading. Remove curtain so that error popup is displayed
    Curtain.remove();
  }, [inCurtain]);

  return (
    <BlockingModalContent actions={action} inCurtain={inCurtain}>
      <L10nText tk="GENERIC_ERROR" placeholder="Please contact Customer Support for assistance" />
    </BlockingModalContent>
  );
};
